import pkoLogo from 'src/assets/icons/banks/pko.svg';
import mbankLogo from 'src/assets/icons/banks/mbank.svg';
import aliorLogo from 'src/assets/icons/banks/alior.svg';
import aliorBusinessLogo from 'src/assets/icons/banks/alior_business.svg';
import ideaLogo from 'src/assets/icons/banks/idea.svg';
import ingLogo from 'src/assets/icons/banks/ing.svg';
import bosLogo from 'src/assets/icons/banks/bos.svg';
import creditAgricoleLogo from 'src/assets/icons/banks/credit-agricole.svg';
import milleniumLogo from '../../assets/icons/banks/millenium.svg';
import milleniumBusinessLogo from 'src/assets/icons/banks/millenium-business.png';
import santanderLogo from 'src/assets/icons/banks/santander.svg';
import ersteLogo from 'src/assets/icons/banks/erste.svg';
import ersteBusinessLogo from 'src/assets/icons/banks/erste-business.svg';
import pekaoLogo from 'src/assets/icons/banks/pekao.svg';
import pekaoBusinessLogo from 'src/assets/icons/banks/pekao_business.svg';
import revolutLogo from 'src/assets/icons/banks/revolut.svg';
import bnpParibasLogo from 'src/assets/icons/banks/bnp-paribas.svg';
import bnpParibasBusinessLogo from '../../assets/icons/banks/bnp-business.svg';
import veloBankLogo from 'src/assets/icons/banks/velo-bank.svg';
import veloBusinessLogo from 'src/assets/icons/banks/velo-business.svg';
import nestBankLogo from 'src/assets/icons/banks/nest-bank.png';
import bankPocztowyLogo from 'src/assets/icons/banks/bank-pocztowy.svg';
import inteligoLogo from 'src/assets/icons/banks/inteligo.png';
import mBankCorporateLogo from 'src/assets/icons/banks/mbank-corporate.png';
import n26Logo from 'src/assets/icons/banks/N26.png';
import payPalLogo from 'src/assets/icons/banks/PayPal.png';
import wiseLogo from 'src/assets/icons/banks/wise.svg';
import creditAgricoleBusinessLogo from 'src/assets/icons/banks/CreditAgricoleBusiness.png';
import otherBankLogo from 'src/assets/icons/banks/otherBankLogo.png';

export enum HealthStatus {
  LIVE = 'LIVE',
  DOWN = 'DOWN',
  NO_CALLS = 'NO CALLS',
}

export enum AspspService {
  AIS = 'AIS',
  PIS = 'PIS',
  COF = 'COF',
}

export interface BankResponse {
  items: AspspItemDTO[];
  otherAspsp: string[];
}

export interface AspspItemDTO {
  aspspServices: AspspService;
  capabilities: {
    [key: string]: boolean;
  };
  health?: {
    aisStatus: HealthStatus;
    lastUpdated: string;
    pisStatus: HealthStatus;
  };
  country: string;
  id: string;
  logo: string | null;
  name: string;
  profile: string;
}

export interface APIAspspItemDTO {
  id: string;
  name: string;
  health?: {
    aisStatus: HealthStatus;
    lastUpdated: string;
    pisStatus: HealthStatus;
  };
  order: number;
}

export interface PublicAspspItemDTO extends APIAspspItemDTO {
  logo: string | null;
}

export enum BankNames {
  PKOBankPolski = 'PKO Bank Polski',
  Santander = 'Santander Bank Polska',
  Erste = 'Erste',
  ErsteBusiness = 'Santander Business',
  mBank = 'mBank',
  ING = 'ING Bank Śląski',
  Pekao = 'Bank Pekao',
  PekaoBusiness = 'Pekao Sa Business',
  CreditAgricole = 'Credit Agricole Group',
  IdeaBank = 'Idea Bank',
  AliorBank = 'Alior Bank',
  AliorBusiness = 'Alior Business',
  BankMillennium = 'Bank Millennium',
  BankMillenniumBusiness = 'Millennium Business',
  BOSBank = 'Bank Ochrony Środowiska SA',
  Revolut = 'Revolut',
  GetinNobleBank = 'Getin Noble Bank',
  GetinBusiness = 'Getin Corporate',
  BNPParibas = 'BGŻ BNP Paribas',
  BNPParibasBusiness = 'Bnp Paribas Business',
  TestScenario2 = 'TestScenario172026',
  TestScenario3 = 'TestScenario202316',
  TestScenario4 = 'TestScenario212878',
  TestScenario5 = 'TestScenario10',
  TestScenario6 = 'TestScenario13',
  TestScenario7 = 'TestScenario4',
  Inteligo = 'Inteligo',
  NestBank = 'Nest Bank',
  BankPocztowy24 = 'Bank Pocztowy',
  IPKO = 'IPKO',
  mBankMsp = 'mBank MSP i korporacje',
  N26 = 'N26',
  Wise = 'Wise',
  PayPal = 'PayPal',
  CreditAgricoleBusiness = 'CreditAgricoleBusiness',
  InnyBank = 'Inny Bank'
}

export const logotypes: Record<BankNames | string, string> = {
  [BankNames.PKOBankPolski]: pkoLogo,
  [BankNames.Santander]: santanderLogo,
  [BankNames.Erste]: ersteLogo,
  [BankNames.ErsteBusiness]: ersteBusinessLogo,
  [BankNames.mBank]: mbankLogo,
  [BankNames.ING]: ingLogo,
  [BankNames.Pekao]: pekaoLogo,
  [BankNames.PekaoBusiness]: pekaoBusinessLogo,
  [BankNames.CreditAgricole]: creditAgricoleLogo,
  [BankNames.IdeaBank]: ideaLogo,
  [BankNames.AliorBank]: aliorLogo,
  [BankNames.AliorBusiness]: aliorBusinessLogo,
  [BankNames.BankMillennium]: milleniumLogo,
  [BankNames.BankMillenniumBusiness]: milleniumBusinessLogo,
  [BankNames.BOSBank]: bosLogo,
  [BankNames.Revolut]: revolutLogo,
  [BankNames.GetinNobleBank]: veloBankLogo,
  [BankNames.GetinBusiness]: veloBusinessLogo,
  [BankNames.BNPParibas]: bnpParibasLogo,
  [BankNames.BNPParibasBusiness]: bnpParibasBusinessLogo,
  [BankNames.TestScenario2]: ersteBusinessLogo,
  [BankNames.TestScenario3]: aliorBusinessLogo,
  [BankNames.TestScenario4]: pekaoBusinessLogo,
  [BankNames.TestScenario5]: veloBusinessLogo,
  [BankNames.TestScenario6]: ersteLogo,
  [BankNames.TestScenario7]: aliorLogo,
  [BankNames.Inteligo]: inteligoLogo,
  [BankNames.NestBank]: nestBankLogo,
  [BankNames.BankPocztowy24]: bankPocztowyLogo,
  [BankNames.IPKO]: pkoLogo,
  [BankNames.mBankMsp]: mBankCorporateLogo,
  [BankNames.CreditAgricoleBusiness]: creditAgricoleBusinessLogo,
  [BankNames.N26]: n26Logo,
  [BankNames.PayPal]: payPalLogo,
  [BankNames.Wise]: wiseLogo,
  [BankNames.InnyBank]: otherBankLogo
};
